import { format } from 'date-fns';

export function formatLastUpdated(updatedAt: number | Date | undefined | null): string {
  if (updatedAt == null) return '';
  const ts = updatedAt instanceof Date ? updatedAt.getTime() : updatedAt;
  if (!ts || ts <= 0) return '';
  const ageSec = Math.max(0, Math.floor((Date.now() - ts) / 1000));
  if (ageSec < 60) return 'Updated just now';
  const ageMin = Math.floor(ageSec / 60);
  if (ageMin < 60) return `Updated ${ageMin} minute${ageMin === 1 ? '' : 's'} ago`;
  return `Updated at ${format(new Date(ts), 'HH:mm')}`;
}
